import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconColumns3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconColumns3"><Path d="M7.66016 21H3V3H7.66016V21Z" fill="currentColor"/><Path d="M14.3398 21H9.66016V3H14.3398V21Z" fill="currentColor"/><Path d="M21 21H16.3398V3H21V21Z" fill="currentColor"/></CentralIconBase>;
});

export default IconColumns3;
